import { html } from '../core/html.js';
import { t } from '../core/i18n.js';

/** The numbered process is shared by the home and services pages. */
export const processSection = ({ number = '04' } = {}) => html`
  <section class="process" aria-labelledby="process-title">
    <div class="shell">
      <div class="process__grid">
        <div class="process__head">
          <div class="section-label">
            <span class="section-label__num">${number}</span>
            <span>${t('process.label')}</span>
          </div>
          <h2 class="process__title" id="process-title">${t('process.title')}</h2>
          <p class="process__lede">${t('process.lede')}</p>
        </div>
        <ol class="process__steps">
          ${[1, 2, 3, 4].map(
            (step) => html`
              <li class="process__step">
                <span class="process__num" aria-hidden="true">${String(step).padStart(2, '0')}</span>
                <h3 class="process__step-title">${t(`process.step${step}.title`)}</h3>
                <p class="process__step-text">${t(`process.step${step}.description`)}</p>
              </li>
            `,
          )}
        </ol>
      </div>
    </div>
  </section>
`;
